import { createAction } from 'redux-actions';
import { SelectedSeat } from '../types';

export interface AddSelectedSeatsPayload {
	segmentId: number;
	passengerId: number;
	seats: Omit<SelectedSeat, 'segmentId' | 'passengerId'>[];
}

export interface RemoveSelectedSeatsPayload {
	segmentId: number;
	passengerId: number;
}

export interface SetSelectedSeatsBySegmentPayload {
	segmentId: number;
	seats: {
		[passengerId: number]: SelectedSeat[];
	};
}

export type AddSelectedSeatsAction = ReturnType<typeof addSelectedSeats>;

export type RemoveSelectedSeatsAction = ReturnType<typeof removeSelectedSeats>;

export type SetSelectedSeatsBySegmentAction = ReturnType<typeof setSelectedSeatsBySegment>;

export const addSelectedSeats = createAction<AddSelectedSeatsPayload>('ADD_SELECTED_SEATS');

export const removeSelectedSeats = createAction<RemoveSelectedSeatsPayload>('REMOVE_SELECTED_SEATS');

export const clearSelectedSeats = createAction('CLEAR_SELECTED_SEATS');

export const setSelectedSeatsBySegment = createAction<SetSelectedSeatsBySegmentPayload>(
	'SET_SELECTED_SEATS_BY_SEGMENT'
);
